/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {fetchCmlDetails} from "../../../api/cmlApi";
import { toast } from "react-toastify";

function useFetchCMLDetails(id) {

    const [cmlShortName, setCmlShortName] = useState(null);
    const [cmlCorrosionLoop, setCmlCorrosionLoop] = useState(null);
    const [cmlSite, setCmlSite] = useState(null);
    const [cmlData, setcmlData] = useState(null);


    const fetchCml = () => {
        fetchCmlDetails(id).then((cmlData) => {
            if (cmlData !== undefined) {
                setCmlShortName(cmlData[0]?.cmLocationName);
                setCmlCorrosionLoop(cmlData[0]?.corrosionLoop);
                setCmlSite(cmlData[0]?.siteId);
                setcmlData(cmlData[0]);
            }
        }).catch((error) => {
            console.error("Error fetching CML info:", error);
            toast.error("Cannot fetch CML info");
        }
        );
    }

    useEffect(() => {
        fetchCml();
    }, [id]);

    return { cmlShortName, cmlCorrosionLoop, cmlSite, cmlData, fetchCml };
}


export default useFetchCMLDetails;